export default function extractImageData(image: Record<string, any>, imageSize: string = 'large'): Record<string, any> {
	return {
		alt: image.alt,
		width: image.width,
		height: image.height,
		image: image.sizes[imageSize],
		placeholder: image.sizes?.placeholder || ''
	}
}
